import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';

import { getTopProperties, ITopBookingsState } from '@store/slices';
import { ILoginState } from '@share/store/slices';
import { RootState } from '@share/utils';
import { CarouselSlider } from '@components';
import { HotelSearchArgs, ITopBookings } from '@common-types';
import HotelCard from './hotel-card';
import { FormattedMessage } from 'react-intl';

interface IMapStateToProps {
  topBookingsStore: ITopBookingsState;
  loginStore: ILoginState;
}

interface IMapDispatchToProps {
  getTopProperties: (account: any) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps {
  withAction: boolean;
}

function FeaturesComponent(props: IProps) {

  useEffect(() => {
    props.getTopProperties(props.loginStore.account);
  }, [])

  const searchHandler: HotelSearchArgs = (location, checkIn, checkOut, rooms, hotelCode) => {
    if (!props.withAction) {
      return;
    }
    const { loginStore, history } = props;
    const { account } = loginStore;
    const dates = { checkIn, checkOut };
    const room = rooms?.map((room) => ({ adultsCount: room.adultsCount, kidsAges: room.kidsAges }))
    history.push(`/${account?.name}/search?dates=${btoa(JSON.stringify(dates))}&location=${btoa(JSON.stringify(location))}&rooms=${btoa(JSON.stringify(room))}`,);
  };

  const { topProperties, loading } = props.topBookingsStore;

  const destination: ITopBookings = topProperties;
  const slidesToShow = (!destination?.items || destination?.items?.length >= 4) ? 4 : destination.items.length;

  if (!!destination?.items?.length && !loading) {
    return (
      <section className='paddingTop-0 featuredSider'>
        <div className="container">
          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="mb-0"><FormattedMessage id="dashboard.featured.hotels" /></h2>
            </div>
          </div>

          <div className="row g-0 g-sm-4">
            <CarouselSlider lazyLoad="progressive" slidesToShow={slidesToShow}>
              {destination.items?.map((hotel, index) => (
                <div key={index} onClick={(e) => { e.preventDefault(), searchHandler(hotel.location, destination?.checkIn, destination?.checkOut, destination?.rooms, hotel?.location?.code) }} className="col-6 col-sm-4 col-lg-3 col-xl-2">
                  <HotelCard key={index} {...hotel} />
                </div>
              ))}
            </CarouselSlider>
          </div>
        </div>
      </section>
    );
  }

  return null;
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    topBookingsStore: state.topBookingsStore,
    loginStore: state.loginStore
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getTopProperties,
};

const Features = connect(mapStateToProps, mapDispatchToProps)(withRouter(FeaturesComponent));
export { Features };